/**
 * Game Loop
 *
 * Handles the main update/render loop at 60 FPS
 */

export class GameLoop {
  private running: boolean = false;
  private lastTime: number = 0;
  private animationFrameId: number | null = null;

  private updateCallback: (deltaTime: number) => void;
  private renderCallback: () => void;

  constructor(
    updateCallback: (deltaTime: number) => void,
    renderCallback: () => void
  ) {
    this.updateCallback = updateCallback;
    this.renderCallback = renderCallback;
  }

  start(): void {
    if (this.running) {
      console.warn('Game loop is already running');
      return;
    }

    this.running = true;
    this.lastTime = performance.now();
    this.loop(this.lastTime);
    console.log('Game loop started');
  }

  stop(): void {
    this.running = false;
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
    console.log('Game loop stopped');
  }

  private loop(currentTime: number): void {
    if (!this.running) return;

    // Calculate delta time in milliseconds
    const deltaTime = currentTime - this.lastTime;
    this.lastTime = currentTime;

    // Update game logic
    this.updateCallback(deltaTime);

    // Render frame
    this.renderCallback();

    // Schedule next frame
    this.animationFrameId = requestAnimationFrame(this.loop.bind(this));
  }

  isRunning(): boolean {
    return this.running;
  }
}
